import styles from './styles.module.scss';
import { Props } from './types';

const Input = ({ label, value, placeholder, onChange, error, icon }: Props) => {
  return (
    <div className={styles.container}>
      <span className={styles.label}>{label}</span>
      <div className={styles.wrapper}>
        <img src={icon} className={styles.icon} />
        <input
          className={styles.input}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
        />
      </div>
      {error ? (
        <span className={styles.error}>{error}</span>
      ) : (
        <div className={styles.placeholder} />
      )}
    </div>
  );
};

export default Input;
